import { Brand } from './brand'
import { SidebarPattern } from './shell-background'
import { SidebarNav } from './sidebar-nav'
import { UserMenu } from './user-menu'

/**
 * Icon-only navigation rail (Deep Purple) with a faded dot texture:
 * logo, main links, then the account at the bottom.
 * Desktop only (`md` and up); mobile uses `BottomNav`.
 */
export function Sidebar() {
  return (
    <div className="relative isolate flex h-full w-sidebar-rail flex-col items-center bg-gradient-to-b from-[#33257a] via-sidebar to-[#17102f] py-4">
      <SidebarPattern />
      <Brand compact />
      <div className="mt-8 flex-1">
        <SidebarNav />
      </div>
      <div className="flex flex-col items-center gap-3">
        <UserMenu />
      </div>
    </div>
  )
}
